import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { ModalOptions } from 'ngx-bootstrap/modal';
import { AlertModelComponent } from '../common/components/alert-model/alert-model.component';
import { ShapeFileModalComponent } from '../common/components/shape-file-modal/shape-file-modal.component';


const components = {
  CONFIRMATION_MODAL: AlertModelComponent,
  ALERT_MODAL: AlertModelComponent,
  SHAPE_MODAL: ShapeFileModalComponent
};

const modalContent = {
  DELETE_CONFIRMATION: {
    titleName: 'Confirm',
    body: 'Are you sure you want to delete?'
  },
  SUBMIT_RTMP: {
    titleName: 'Confirm',
    body: 'Are you sure you want to submit the RTMP application?'
  },
  DELETE_DRAFT: {
    titleName: 'Confirm',
    body: 'Are you sure you want to delete the draft application?'
  },
  CONFIRM_DELETE_QUOTECREDIT: {
    titleName: 'Confirm',
    body: 'Are you sure you want to delete this quote credit?'
  },
  SHAPE_MODAL:{
    titleName: 'Upload Shape File',
    body: 'Are you sure you want to upload this shape file?',
    UrlString: ''
  }
};


@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    private modalService: NgbModal,
    private injector: Injector
  ) { }

  public openModal(tabName?: string, type?: any, options?: NgbModalOptions, details?: any): NgbModalRef {
    const component: any = components[tabName];
    const dataForModal: {titleName: string, body: string} = type ? modalContent[type] : this.doNothing() ;
    const modalRef = this.modalService.open(component, {
      centered: options && options.centered ? options.centered : true,
      ariaLabelledBy: options && options.ariaLabelledBy ? options.ariaLabelledBy : 'modal-basic-title',
      size: options && options.size ? options.size : 'xl',
      keyboard: options && options.keyboard ? options.keyboard : false,
      backdrop:options &&  options.backdrop ? options.backdrop : 'static',
      windowClass: options && options.windowClass ? options.windowClass : 'modalSamll'
    });

    // Set the modal data directly on the component instance
    if (dataForModal) {
      modalRef.componentInstance.title = dataForModal.titleName;
      modalRef.componentInstance.message = dataForModal.body;
    }
    if (details) {
      modalRef.componentInstance.data = details;
    }

    return modalRef;
  }

  public openShapeModal(tabName?: string, type?: any, options?: NgbModalOptions, details?: any): NgbModalRef {
    const component: any = components[tabName];
    const dataForModal: {titleName: string, body: string, UrlString: string} = type ? modalContent[type] : this.doNothing() ;
    const modalRef = this.modalService.open(component, {
      centered: options && options.centered ? options.centered : true,
      ariaLabelledBy: options && options.ariaLabelledBy ? options.ariaLabelledBy : 'modal-basic-title',
      size: options && options.size ? options.size : 'xl',
      keyboard: options && options.keyboard ? options.keyboard : false,
      backdrop:options &&  options.backdrop ? options.backdrop : 'static',
      windowClass: options && options.windowClass ? options.windowClass : 'modalSamll'
    });

    // Set the modal data directly on the component instance
    if (dataForModal) {
      modalRef.componentInstance.title = dataForModal.titleName;
      modalRef.componentInstance.message = dataForModal.body;
      modalRef.componentInstance.UrlString = dataForModal.UrlString;
    }
    if (details) {
      modalRef.componentInstance.data = details;
    }

    return modalRef;
  }

  buildHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Authorization', `Bearer ${sessionStorage.getItem('auth-token')}`);
    return headers;
  }

  doNothing(): void {
  }
}
